import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import { useSelector, useDispatch } from "react-redux";
import { useMediaQuery } from "./useMediaQuery";
import { getTheme } from "../SharedComponents/ThemeComponent";
import { getRole } from "../Core/utils/auth";
import { toggleDarkMode } from "../Redux/Reducers/darkModeSlice";
import { showSidebarStatus } from "../Redux/Reducers/sidebarSlice";

/**
 * Encapsulates all state, derived values, and side-effects for the ProtectedRoute component.
 * @returns {{ state: object, derived: object, handlers: object }}
 */
function useProtectedRoute() {
  const dispatch = useDispatch();
  const location = useLocation();
  const theme = getTheme();

  const role = getRole();
  const isSidebarVisible = useSelector(showSidebarStatus);
  const isDesktop = useMediaQuery("(min-width: 960px)");

  const handleToggle = () => {
    dispatch(toggleDarkMode());
  };

  useEffect(() => {
    if (process.env.REACT_APP_ENABLE_NEWRELIC === "1") {
      const script = document.createElement("script");
      script.src = `/scripts/newrelic_browser_agent.js`;
      script.defer = true;
      document.head.appendChild(script);
    }
  }, []);

  return {
    state: { role, isSidebarVisible, location },
    derived: { isDesktop, theme },
    handlers: { handleToggle },
  };
}

export default useProtectedRoute;
